import moment from 'moment';

export class MessageArea {
  constructor(area) {
    this.area = area;
  }
  getMsg(messageId, formatArray) {
    if (typeof messageId !== 'string') {
      throw new TypeError(`Message name must be a string. Got ${typeof messageId} instead.`);
    }
    let message = this.area[messageId];
    if (!message) return `Missing text: ${messageId}`;
    if (formatArray) {
      if (!Array.isArray(formatArray) || !formatArray.every(type => typeof type === 'string')) {
        throw new Error('Translation string format error: Expected an array of strings.');
      }
      formatArray.forEach((el, index) => {
        message = message.replace(`{${index}}`, el);
      });
    }
    return message;
  }
  toObject() {
    return this.area;
  }
}

export class GlobalsHandler {
  constructor(globals) {
    this.globals = globals;

    const areaKeys = Object.keys(this.globals.messages);
    areaKeys.forEach(el => {
      this[el] = new MessageArea(this.globals.messages[el]);
    });

    this.initializeTimeDifference();
  }
  // Set the time difference between the server and the browser.
  initializeTimeDifference() {
    const momentNow = moment();
    const serverMomentNow = moment(this.globals.serverNow);
    // Difference limited to hours ignores the request time difference.
    // Would be wrong if the request took more than an hour, but timeout duration is lower.
    this.timeDifferenceInHours = serverMomentNow.diff(momentNow, 'h');
  }

  getArea(areaName) {
    if (typeof areaName !== 'string') {
      throw new TypeError(`Area name must be a string. Got ${typeof areaName} instead.`);
    }
    if (!this.globals.messages[areaName]) {
      throw new ReferenceError(`${areaName} does not exist in Messages!`);
    }
    return this[areaName];
  }

  // If duplicate keys exist, the one from the last area in the list will overwrite the previous
  getAreas(areaNames) {
    if (!Array.isArray(areaNames)) {
      throw new Error('Area names array format error: Expected an array of strings.');
    }
    let result = {};
    areaNames.forEach(areaName => {
      result = { ...result, ...this.getArea(areaName).toObject() };
    });
    return new MessageArea(result);
  }

  // Source of current time for all the elements in the application.
  // Returns a new moment date everytime, so it stays true even if it's already past midnight
  // and the page hasn't been refreshed.
  // Considers the time difference between the browser and the server (works with virtual date).
  getCurrentDate = (browserTime = false) =>
    browserTime ? moment() : moment().add(this.timeDifferenceInHours, 'hours');

  get applicationFeatureAccesses() {
    return this.globals.applicationFeatureAccesses;
  }

  get urls() {
    return this.globals.urls;
  }

  get consts() {
    return this.globals.consts;
  }

  get version() {
    return this.globals.version;
  }

  get instance() {
    return this.globals.instance;
  }

  get dateFormats() {
    return this.globals.dateFormats;
  }

  get timeFormats() {
    return this.globals.timeFormats;
  }

  get durationFormats() {
    return this.globals.durationFormats;
  }

  get momentLocale() {
    return this.globals.dateFormats.momentLocale;
  }

  get weekdayNames() {
    return this.globals.dateFormats.weekdaysShort;
  }

  get identityProvider() {
    return this.globals.identityProvider;
  }

  get now() {
    return this.getCurrentDate();
  }
  // In case the actual browser date is ever needed
  get browserNow() {
    return this.getCurrentDate(true);
  }

  get dataDogSettings() {
    return this.globals.dataDog;
  }
}

const CSGlobals = new GlobalsHandler(window.CS.Globals);
export default CSGlobals;
